// src/layouts/MainLayout.tsx
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { cn } from '../../lib/utils';

const MainLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // auto-collapse on very narrow screens (optional)
  useEffect(() => {
    const handle = () => {
      if (window.innerWidth < 768) setIsCollapsed(true);
    };
    handle();
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  return (
    <div className="relative min-h-screen bg-background">
      {/* Desktop Sidebar */}
      <Sidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
      />

      {/* Top Navbar – always visible */}
      {/* <Navbar
        isCollapsed={isCollapsed}
        onMenuToggle={() => setIsMobileOpen(true)}
      /> */}

      <Navbar isCollapsed={isCollapsed} onMenuToggle={() => setIsMobileOpen(true)} />

      {/* Main content */}
      <main
        className={cn(
          'pt-16 transition-all duration-300',
          // desktop offset
          isCollapsed ? 'md:ml-16' : 'md:ml-64',
          // mobile padding for fixed navbar
          'pb-6 md:pb-0'
        )}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>

      {/* Mobile backdrop (only when drawer open) */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 md:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}
    </div>
  );
};

export default MainLayout;